// src/store/returnPathSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  path: null,
  fromComponent: null
};

const returnPathSlice = createSlice({
  name: 'returnPath',
  initialState,
  reducers: {
    setReturnPath: (state, action) => {
      state.path = action.payload.path;
      state.fromComponent = action.payload.fromComponent;
      console.log(state);
    },
    clearReturnPath: (state) => {
      state.path = null;
      state.fromComponent = null;
    }
  }
});

export const { setReturnPath, clearReturnPath } = returnPathSlice.actions;
export default returnPathSlice.reducer;